<div class="billing-setup">

  <!-- Header -->
  <div class="section-header">
    <mat-icon class="section-icon">credit_card</mat-icon>
    <div>
      <h2 class="section-title">Billing Setup (Optional)</h2>
      <p class="section-subtitle">
        Connect billing when you exceed your free tier limits. You can set this up anytime—no rush!
      </p>
    </div>
  </div>

  <mat-divider *ngIf="!billingActive"></mat-divider>

  <!-- Free tier info (only show if not already set up) -->
  <div *ngIf="!billingActive" class="free-tier-card">
    <h3 class="free-tier-title">
      <mat-icon class="free-icon">card_giftcard</mat-icon>
      Your Free Monthly Limits
    </h3>
    <p class="free-tier-subtitle">These features are FREE each month—no billing needed:</p>

    <div class="free-tier-items">
      <div class="free-tier-item">
        <div class="item-icon">
          <mat-icon>receipt_long</mat-icon>
        </div>
        <div class="item-content">
          <strong>Cash &amp; Check Donations</strong>
          <p>200 donations/month free</p>
          <span class="fine-print">Then $0.10 per donation</span>
        </div>
      </div>

      <div class="free-tier-item">
        <div class="item-icon">
          <mat-icon>email</mat-icon>
        </div>
        <div class="item-content">
          <strong>Communications</strong>
          <p>200 emails/month free</p>
          <span class="fine-print">Then $0.005 per email</span>
        </div>
      </div>
    </div>
  </div>

  <mat-divider *ngIf="!billingActive"></mat-divider>

  <!-- When to connect billing (only show if not already set up) -->
  <div *ngIf="!billingActive" class="when-to-connect-card">
    <h3 class="when-title">
      <mat-icon class="when-icon">info_outline</mat-icon>
      When to Connect Billing
    </h3>
    <p class="when-subtitle">You'll need to connect billing if you expect to:</p>

    <ul class="when-list">
      <li>Process <strong>more than 200 cash/check donations per month</strong>, or</li>
      <li>Send <strong>more than 200 communications per month</strong> (broadcasts, reminders, re-sends)</li>
    </ul>

    <p class="when-note">
      If you're unsure, skip for now! You can connect billing anytime from your Organization Console once you know your actual usage.
    </p>
  </div>

  <!-- Already configured state -->
  <div *ngIf="billingActive">
    <mat-divider></mat-divider>
    <div class="success-state">
    <div class="success-icon-row">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <span class="success-title">Billing Connected ✓</span>
    </div>
    <div class="bank-detail">
      <mat-icon>account_balance</mat-icon>
      <span>{{ bankName || 'Bank' }} ending in <strong>{{ bankLast4 || '****' }}</strong></span>
    </div>
    <p class="success-note">
      You're all set! You enjoy 200 free cash/check donations and 200 free emails per month. If you exceed these limits, we'll automatically bill this account on the 1st of the month for any overage charges. You can update your bank account anytime from the Organization Console.
    </p>
    <button mat-flat-button color="primary" (click)="onContinue()">
      <mat-icon>arrow_forward</mat-icon>
      Continue
    </button>
    </div>
  </div>

  <!-- Setup actions -->
  <div *ngIf="!billingActive">
    <mat-divider></mat-divider>
    <div class="actions">
    <button
      mat-flat-button
      color="primary"
      (click)="linkBankAccount()"
      [disabled]="isSettingUp || isConfirming"
      class="link-btn"
    >
      <mat-spinner *ngIf="isSettingUp || isConfirming" diameter="20" class="btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!isSettingUp && !isConfirming">link</mat-icon>
      <span *ngIf="isSettingUp">Connecting to Stripe...</span>
      <span *ngIf="isConfirming">Confirming account...</span>
      <span *ngIf="!isSettingUp && !isConfirming">Connect Billing Now</span>
    </button>

    <button
      mat-stroked-button
      (click)="onSkip()"
      [disabled]="isSettingUp || isConfirming"
      class="skip-btn"
    >
      I'll Set This Up Later
    </button>
    </div>
  </div>

  <!-- Loading state hint (only show if not already set up and setting up) -->
  <div *ngIf="!billingActive && isSettingUp" class="loading-hint">
    <mat-icon>lock_outline</mat-icon>
    <p>A secure Stripe window will open. Link your bank account to be ready for overages beyond your free tier.</p>
  </div>

</div>
